import { base } from './base.js';

export function defaultCard(card) {
  return base({
    icon: card.icon || '',
    title: card.title?.text || '',
    content: card.content?.text || '',
    button: card.button || null,
    titleColor: card.title?.text_color ?? '',
    contentColor: card.content?.text_color ?? '',
    hideWhenReload: card.hide_when_reload === true,
  });
}
